// Pages (DB) tab — edits the DB-driven content blocks for the homepage and BC
// content pages (Neon page_content, page_type='page'). Reuses PageBlocksEditor.
import React, { useState, useEffect } from 'react';
import PageBlocksEditor from './PageBlocksEditor';
import { getActiveEnv } from '../../services/env';
import { fetchAllPages } from './siteContentShared';
import { neonQuery } from '../../services/api';

const STORE_DOMAINS = {
  sb1: 'the-crab-place-sandbox-1.mybigcommerce.com',
  sb2: 'the-crab-place-sandbox-2.mybigcommerce.com',
  prod: 'www.crabplace.com',
};

export default function SiteContentPagesTab() {
  const env = getActiveEnv();
  const [pages, setPages] = useState([{ name: 'Homepage', key: '/' }]);
  const [key, setKey] = useState('/');
  const [loading, setLoading] = useState(false);

  // Only list pages that actually have DB content blocks — no point showing the
  // hundreds of BC pages we have nothing for. Names come from BC; keys from Neon.
  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const [bcPages, dbRes] = await Promise.all([
          fetchAllPages('/v3/content/pages').catch(() => []),
          neonQuery('page_content_list', { page_type: 'page', env }),
        ]);
        if (!alive) return;
        const rows = Array.isArray(dbRes) ? dbRes : (dbRes && dbRes.rows) || [];
        const nameByUrl = {};
        (bcPages || []).forEach(bp => { if (bp.url) nameByUrl[bp.url] = bp.name; });
        const list = rows
          .map(r => ({ key: r.key, name: r.key === '/' ? 'Homepage' : (nameByUrl[r.key] || r.key) }))
          .sort((a, b) => (a.key === '/' ? -1 : b.key === '/' ? 1 : a.name.localeCompare(b.name)));
        if (list.length) {
          setPages(list);
          if (!list.some(x => x.key === key)) setKey(list[0].key);
        }
      } catch (e) { /* keep default on failure */ }
      finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, [env]); // eslint-disable-line react-hooks/exhaustive-deps

  const viewUrl = key ? ('https://' + STORE_DOMAINS[env] + key) : null;

  return (
    <div style={{ padding: '4px 2px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
        <span style={{ fontSize: 12, fontWeight: 600, padding: '3px 8px', borderRadius: 4, background: '#eef2ff', color: '#3730a3' }}>Editing env: {env.toUpperCase()}</span>
        <span style={{ fontSize: 12, color: '#6b7280' }}>Homepage + content pages, stored in Neon. No Page Builder.</span>
      </div>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Page</label>
      <select value={key} onChange={e => setKey(e.target.value)} disabled={loading}
        style={{ width: '100%', maxWidth: 520, padding: '8px 10px', fontSize: 14, marginBottom: 16, border: '1px solid #d1d5db', borderRadius: 6 }}>
        {loading && <option>Loading pages…</option>}
        {pages.map(p => <option key={p.key} value={p.key}>{p.name}  ({p.key})</option>)}
      </select>
      <PageBlocksEditor pageType="page" pageKey={key} env={env} viewUrl={viewUrl} />
    </div>
  );
}
